import { X } from "lucide-react";

const AIAssistantHeader = ({ onClose }) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-border">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center">
          <span className="text-xs font-semibold text-white">AI</span>
        </div>
        <h2 className="font-semibold text-center">aka AI Pro</h2>
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={onClose}
          className="p-1.5 rounded-full hover:bg-secondary transition-colors"
        >
          <X size={18} className="text-gray-600" />
        </button>
      </div>
    </div>
  );
};
export default AIAssistantHeader;
